import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";

import Avatar from "@mui/material/Avatar";

import Icon from "../../Icon/Icon";

const SuggestionCard = ({ avatar, username, fullName, posts, children }) => {
  const history = useHistory();

  const getMedia = (post) => {
    const mediaItem = post.mediaItems && post.mediaItems[0];
    if (!mediaItem) {
      return {
        mediaType: "image",
        thumbnail: post.thumbnail || post.image || null,
        mediaUrl: post.image || null,
        filter: post.filter || "",
      };
    }
    return {
      mediaType: mediaItem.mediaType || "image",
      thumbnail: mediaItem.thumbnailUrl || mediaItem.mediaUrl,
      mediaUrl: mediaItem.mediaUrl,
      filter: mediaItem.filter || "",
    };
  };

  return (
    <div className="suggestion-card">
      <Avatar
        onClick={() => history.push("/" + username)}
        className="avatar--large mb-sm"
        src={avatar}
      />
      <h4 className="heading-4 font-bold">{username}</h4>
      <h4 className="heading-4 color-grey font-medium">{fullName}</h4>
      <div className="suggestion-card__content">
        {posts.length > 0 ? (
          posts.map((post, idx) => {
            const media = getMedia(post);
            const isVideo = media.mediaType === "video";
            return (
              <figure className="suggestion-card__image-container" key={idx}>
                {isVideo ? (
                  <Fragment>
                    <video
                      src={media.mediaUrl}
                      poster={media.thumbnail}
                      muted
                      loop
                      playsInline
                    />
                    <span className="suggestion-card__video-badge">
                      <Icon icon="play" className="icon--white" />
                    </span>
                  </Fragment>
                ) : (
                  <img
                    src={media.thumbnail}
                    alt="User post"
                    style={{ filter: media.filter }}
                  />
                )}
              </figure>
            );
          })
        ) : (
          <Fragment>
            <div style={{ padding: "2rem" }}>
              <h3 className="heading-4 font-bold">No Posts</h3>
              <h4 className="heading-5 font-medium color-grey">
                This user has no posts yet, follow them to see their future
                posts.
              </h4>
            </div>
          </Fragment>
        )}
      </div>

      <div className="suggestion-card__footer">
        <h5 className="heading-5 color-grey font-medium">Random</h5>
        {children}
      </div>
    </div>
  );
};

export default SuggestionCard;

